import React from 'react';
import Styles from './result-styles.scss';
import { Calendar } from '@/presentation/components';
import { useNavigate } from 'react-router';
import Answer from '../answer/answer';
const Result = ({ surveyResult }) => {
    const navigate = useNavigate();
    return (React.createElement(React.Fragment, null,
        React.createElement("hgroup", null,
            React.createElement(Calendar, { date: surveyResult.date, className: Styles.calendarWrap }),
            React.createElement("h2", { "data-testid": "question" }, surveyResult.question)),
        React.createElement("ul", { className: Styles.answersList, "data-testid": "answers" }, surveyResult.answers.map(answer => (React.createElement(Answer, { key: answer.answer, answer: answer })))),
        React.createElement("button", { className: Styles.button, "data-testid": "back-button", onClick: () => navigate(-1) }, "Back")));
};
export default Result;
